import { render, staticRenderFns } from "./join-team.vue?vue&type=template&id=4397b997&scoped=true"
import script from "./join-team.vue?vue&type=script&lang=js"
export * from "./join-team.vue?vue&type=script&lang=js"
import style0 from "./join-team.vue?vue&type=style&index=0&id=4397b997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4397b997",
  null
  
)

export default component.exports